import classNames from 'classnames';
import React from 'react';
import { CheckPicker, SelectPicker } from 'rsuite';

import { CheckPickerProps } from 'rsuite/lib/CheckPicker';
interface FilterProps extends CheckPickerProps {
  isMultiple: boolean;
  selectedItemsId: string[] | string;
}
export const Filter = ({ selectedItemsId, isMultiple, data, ...props }: FilterProps) => {
  const { renderValue, ...restProps } = props;

  return (
    <div className={classNames('info-filter-mini-picker')}>
      {isMultiple ? (
        <CheckPicker
          style={{ maxWidth: '300px' }}
          cleanable
          appearance="default"
          type="select"
          value={selectedItemsId as string[]}
          data={data}
          renderValue={(value: string | any[]) => (
            <>
              <span>{value && props?.placeholder}</span>
              <span className="counter">{value && value?.length}</span>
            </>
          )}
          {...restProps}
        />
      ) : (
        <SelectPicker
          style={{ maxWidth: '300px' }}
          appearance="default"
          filter={false}
          value={selectedItemsId}
          data={data}
          locale={{
            noResultsText: data.length === 0 ? 'Carregando...' : 'Nenhum item encontrado',
            searchPlaceholder: 'Pesquisar',
          }}
          {...restProps}
        />
      )}
    </div>
  );
};
